import { msg, select } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useController, useFormContext } from 'react-hook-form';
import CustomMenu from '@/components/menu/menu';
import { type OrderType, TiF } from '@/feature/order_entry/order_types';
import type { OrderFormData } from '../order_schema';

type FormValues = Extract<
  OrderFormData,
  {
    orderType: typeof OrderType.limit | typeof OrderType.stopLimit | typeof OrderType.stopMarket;
  }
>;

const menuItemShorts = {
  [TiF.gtc]: 'GTC',
  [TiF.immediateOrCancel]: 'IoC',
  [TiF.fillOrKill]: 'FoK',
  [TiF.postOnly]: 'PO',
};

export function TiFView() {
  const { i18n, t } = useLingui();
  const context = useFormContext<FormValues>();
  const isSmallScreen = useMediaQuery(`(max-width:1400px)`);
  const menuItems = [
    {
      id: TiF.gtc,
      label: t({ comment: 'Good unTil Cancel', message: 'Good ’Til Cancel' }),
      shortLabel: 'GTC',
    },
    {
      id: TiF.immediateOrCancel,
      label: t({ comment: 'Immediate Or Cancel', message: 'Immediate Or Cancel' }),
      shortLabel: 'IoC',
    },
    {
      id: TiF.fillOrKill,
      label: t({ comment: 'Fill Or Kill', message: 'Fill Or Kill' }),
      shortLabel: 'FoK',
    },
    {
      id: TiF.postOnly,
      label: t({ comment: 'Post Only', message: 'Post Only' }),
      shortLabel: 'PO',
    },
  ];

  const { field } = useController({
    name: 'tif',
    control: context.control,
    defaultValue: TiF.gtc,
  });

  return (
    <CustomMenu
      value={field.value ?? TiF.gtc}
      items={menuItems}
      renderItem={(item) => item.label}
      renderLabel={(item) => {
        return isSmallScreen
          ? menuItemShorts[item]
          : i18n._(
              msg({
                comment: 'TIF menu item',
                message: select(
                  { item },
                  {
                    gtc: 'Good ’Til Cancel',
                    immediateOrCancel: 'Immediate Or Cancel',
                    fillOrKill: 'Fill Or Kill',
                    postOnly: 'Post Only',
                    other: '',
                  }
                ),
              })
            );
      }}
      buttonProps={{
        size: 'small',
        variant: 'text',
        color: 'secondary',
      }}
      menuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      }}
      onSelect={(item) => field.onChange(item.id)}
    />
  );
}
